import { MutableRefObject, createContext } from 'react';
import { IListParamsState } from '../types';

type IListParamsContext = {
	listParamsRef: MutableRefObject<IListParamsState>;
};

export const ListParamsContext = createContext<IListParamsContext>({} as IListParamsContext);
